import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import './CreateProduct.css';
import {
    makeStyles, Paper, Button, CircularProgress, FormControl, FormControlLabel, Radio, RadioGroup, Divider
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import clsx from 'clsx';
import classNames from 'classnames';
import { convertToRaw, EditorState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { sportEvent } from '../Models/ProductsModel';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import CustomAlert from '../CustomAlert';
import CheckUserProvider from '../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import { createSportEventDocument } from '../../Backend/firebase/sport-event';
import { EntryFeeInputRow } from './EntryFeeInputRow';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
        padding: '20px'
    },
}));

function CreateSportEvent() {
    const { register, handleSubmit, errors, reset } = useForm();
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const [eventDescription, setEventDescription] = useState(() => EditorState.createEmpty());
    const [aboutTheTournament, setAboutTheTournament] = useState(() => EditorState.createEmpty());
    const [awardsAndPrizes, setAwardsAndPrizes] = useState(() => EditorState.createEmpty());
    const [categories, setCategories] = useState(() => EditorState.createEmpty());
    const [rulesAndRegulations, setRulesAndRegulations] = useState(() => EditorState.createEmpty());
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [registrationClosingDate, setRegistrationClosingDate] = useState(new Date())
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { userData } = CheckUserProvider();
    const [isEntryFree, setIsEntryFree] = useState('');
    const [entryFeeFields, setEntryFeeFields] = useState([
        {
            uniqueId: "",
            entryCategory: "",
            entryFees: "",
        }
    ]);

    const onSubmit = async (data) => {
        setIsLoading(true);
        const eventDescriptionValue = convertToRaw(eventDescription.getCurrentContent());
        const aboutTheTournamentValue = convertToRaw(aboutTheTournament.getCurrentContent());
        const awardsAndPrizesValue = convertToRaw(awardsAndPrizes.getCurrentContent());
        const categoriesValue = convertToRaw(categories.getCurrentContent());
        const rulesAndRegulationsValue = convertToRaw(rulesAndRegulations.getCurrentContent());
        // if (eventDescription.getCurrentContent().hasText()) {
            sportEvent.userId = userData.uid;
            sportEvent.tournamentName = data.tournamentName;
            sportEvent.eventCategory = "Healthy Sports Events";
            sportEvent.location = data.location;
            sportEvent.organizerName = data.organizerName;
            sportEvent.contactNumber = data.contactNumber;
            sportEvent.startDate = startDate;
            sportEvent.endDate = endDate;
            sportEvent.registrationClosingDate = registrationClosingDate;
            sportEvent.eventImage = null
            sportEvent.eventDescription = String(JSON.stringify(eventDescriptionValue));
            sportEvent.aboutTheTournament = String(JSON.stringify(aboutTheTournamentValue));
            sportEvent.awardsAndPrizes = String(JSON.stringify(awardsAndPrizesValue));
            sportEvent.categories = String(JSON.stringify(categoriesValue));
            sportEvent.rulesAndRegulations = String(JSON.stringify(rulesAndRegulationsValue));
            sportEvent.isEntryFree = isEntryFree;
            sportEvent.entryFeeFields = entryFeeFields;
            sportEvent.eventStatus = 'New';
            try {
                var event = createSportEventDocument(sportEvent);
                if (event) {
                    setNotificationMessage('Event created successfully.');
                    setOpenNotify(true);
                    setAlertType('success');
                    reset();
                    setEventDescription(EditorState.createEmpty());
                    setIsLoading(false);
                    setTimeout(routeToPages, 2000);
                } else {
                    setNotificationMessage('Something went wrong, Please try again later!!');
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsLoading(false);
                    history.push('/retailer/create-health-camps');
                }
            }  catch (error) {
                console.error(error);
                setNotificationMessage('Something went wrong, Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
                history.push('/retailer/create-health-camps');
            }
        // } else {
        //     setNotificationMessage("Please enter event description!");
        //     setOpenNotify(true);
        //     setAlertType('error');
        //     setIsLoading(false);
        // }
    };

    const routeToPages = () => {
        window.location.pathname = '/retailer/sport-events';
    }

    const onEditorStateChange = (editorState) => {
        setEventDescription(editorState);
    };

    const onEditorAboutTheTournamentStateChange = (editorState) => {
        setAboutTheTournament(editorState);
    };

    const onEditorAwardsAndPrizesStateChange = (editorState) => {
        setAwardsAndPrizes(editorState);
    };

    const onEditorCategoriesStateChange = (editorState) => {
        setCategories(editorState);
    };

    const onEditorRulesAndRegulationsStateChange = (editorState) => {
        setRulesAndRegulations(editorState);
    };

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
    }

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
    }

    const handleRegistrationClosingDateChange = (e) => {
        setRegistrationClosingDate(e.target.value);
    }

    const handleIsEntryFreeChange = (event) => {
        setIsEntryFree(event.target.value);
    };

    const handleEntryFeesAdd = () => {
        setEntryFeeFields([
            ...entryFeeFields,
            {
                uniqueId: "",
                entryCategory: "",
                entryFees: "",
            }
        ])
    }
    const handleEntryFeesRemove = (index) => {
        if (entryFeeFields.length !== 1) {
            const values = [...entryFeeFields]
            values.splice(index, 1)
            setEntryFeeFields(values)
        }
    }
    const handleEntryFeesChange = (event, index) => {
        const uniqueId = uuidv4();
        const values = [...entryFeeFields]
        values[index][event.target.name] = event.target.value
        values[index]["uniqueId"] = uniqueId

        setEntryFeeFields(values)
    }

    return (
        <>
            <div className="createProduct mt-2">
                <Helmet>
                    <meta name="description" content="Creating New event Event." />
                    <title>Create New Sport Event | Kaipsool Pharmatech</title>
                </Helmet>
                <Paper className={fixedHeightPaper}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <div className="col-md-12 mb-2">
                                Tournament Name <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.tournamentName })}
                                    name="tournamentName" autoComplete="none"
                                    ref={register({ required: 'Please enter Name of the Event!' })} />
                                <small className="form-text text-danger">{errors.tournamentName && errors.tournamentName.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                               Organizer Name <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.organizerName })}
                                    name="organizerName" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Organizer!' })} />
                                    <small className="form-text text-danger">{errors.organizerName && errors.organizerName.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Contact Number <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox")}
                                    name="contactNumber" autoComplete="none"
                                    ref={register} />
                                    <small className="form-text text-danger">{errors.contactNumber && errors.contactNumber.message}</small>
                            </div>
                            {/* <div className="col-md-6 mb-2">
                                Event Category <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <select className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.eventCategory })} aria-label="Default select example"
                                    name="eventCategory" ref={register({
                                        required: 'Please select Event Category!',
                                        validate: {
                                            defaultValue: value => value !== "Select Event Category" || 'Please select event Category!'
                                        }
                                    })} defaultValue="Select Event Category">
                                    <option value="Healthy Sports Events">Healthy Sports Events</option>
                                </select>
                            </div> */}
                            <div className="col-md-12 mb-2">
                                Location <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.location })}
                                    name="location" autoComplete="none"
                                    ref={register({ required: 'Please enter Location!' })} />
                                <small className="form-text text-danger">{errors.location && errors.location.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Start Date <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <DatePickerComponent
                                    id="startDate"
                                    value={startDate}
                                    name='startDate'
                                    cssclassName="e-outline"
                                    onChange={(e) => handleStartDateChange(e)}
                                    ref={register({ required: 'Please enter Start Date!' })}
                                />
                                <small className="form-text text-danger">{errors.startDate && errors.startDate.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                End Date <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <DatePickerComponent
                                    id="endDate"
                                    value={endDate}
                                    name='endDate'
                                    cssclassName="e-outline"
                                    onChange={(e) => handleEndDateChange(e)}
                                    ref={register({ required: 'Please enter End Date!' })}
                                />
                                <small className="form-text text-danger">{errors.endDate && errors.endDate.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Registration closing date <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <DatePickerComponent
                                    id="registrationClosingDate"
                                    value={registrationClosingDate}
                                    name='registrationClosingDate'
                                    cssclassName="e-outline"
                                    onChange={(e) => handleRegistrationClosingDateChange(e)}
                                    ref={register({ required: 'Please enter Registration closing date!' })}
                                />
                                <small className="form-text text-danger">{errors.registrationClosingDate && errors.registrationClosingDate.message}</small>
                            </div>
                            <div className="col-md-6 mb-2 createProduct__labelValign"></div>
                            <h4 className="mt-4 border__bottom">Descriptions</h4>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>About the Tournament</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={aboutTheTournament} onEditorStateChange={onEditorAboutTheTournamentStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>Awards & Prizes</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={awardsAndPrizes} onEditorStateChange={onEditorAwardsAndPrizesStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>Categories</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={categories} onEditorStateChange={onEditorCategoriesStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>Rules & Regulations</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={rulesAndRegulations} onEditorStateChange={onEditorRulesAndRegulationsStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>Other Details </b>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={eventDescription} onEditorStateChange={onEditorStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <h4 className="mt-4 border__bottom">Entry Fees</h4>
                            <div className="col-md-12 mb-2 mr-3">
                                <div className="col-md-10 mb-2">
                                    <FormControl component="fieldset">
                                        <RadioGroup aria-label="isEntryFree" name="isEntryFree" row>
                                            <FormControlLabel value="Free" control={<Radio checked={isEntryFree === 'Free'}
                                                onChange={handleIsEntryFreeChange}
                                                value="Free"
                                                className="skilsForm__radioBtn" />}
                                                label="Free"
                                                name="isEntryFree"
                                                inputRef={register}
                                                className="updateProduct__hoursPerWeek" />
                                            <FormControlLabel value="Entry Fees reqiured" control={<Radio checked={isEntryFree === 'Entry Fees reqiured'}
                                                onChange={handleIsEntryFreeChange}
                                                value="Entry Fees reqiured"
                                                className="skilsForm__radioBtn" />}
                                                label="Entry Fees reqiured"
                                                name="isEntryFree"
                                                inputRef={register}
                                                className="updateProduct__hoursPerWeek" />
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                                <div className="col-md-2 mb-2"></div>
                            </div>
                            <div className="row mb-3">
                                {entryFeeFields.map((item, index) => (
                                    <>
                                        <div key={index}>
                                            <EntryFeeInputRow
                                                errors={errors}
                                                register={register}
                                                inputFields={entryFeeFields}
                                                index={index}
                                                item={item}
                                                handleForm={null}
                                                handleChange={handleEntryFeesChange}
                                                handleRemove={handleEntryFeesRemove}
                                                handleAdd={handleEntryFeesAdd}
                                            />
                                        </div>
                                        <Divider />
                                    </>
                                ))}
                            </div>
                            <div className="col-sm-12 text-right mt-2">
                                <div className="d-flex justify-content-center">
                                    <div className="p-2">
                                        <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                            {isLoading ? <CircularProgress size={18} /> : 'Create Event'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Paper>
            </div>
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} verticalPosition="bottom" horizontalPosition="center" />
        </>
    )
}

export default CreateSportEvent

